import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IFontProps {
  backgroundColorValue?: string;
  rotationValue?: string;
  cropping?: boolean;
  active?:boolean;
}

export const Root = styled.div`
  display: flex;
  gap:7px;
  align-items: center;
  height: 100%;
  position: relative;
  padding: 0px 4px;
`;

export const IconContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 31px;
  border-radius: 5px;
  background-color: ${(props: IFontProps) => (props.backgroundColorValue ? props.backgroundColorValue : 'auto')};
  &:hover {
    background-color: ${C.DARK_BLUE};
  }
`;

export const ButtonContainer = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: ${C.WHITE};
  display:flex;
  height: 31px;
  padding: 0px 4px;
  margin:0px 0px 0px 0px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
      background-color: ${(props: IFontProps) => (props.active ? C.GRAY : '')};
      cursor: ${(props: IFontProps) => (props.active ? 'pointer' : 'not-allowed')};
    }
`;

export const Line = styled.div`
    border-left: 1px solid rgba(204, 204, 204, 0.3);;
    height: 21px;
`;